export default __webpack_public_path__ + "static/media/Maskgroup4.7670119f.svg";